webpackJsonp([70144966829960],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Address = function Address(_ref) {
	  var address = _ref.address;
	
	  return _react2.default.createElement(
	    'address',
	    null,
	    address.map(function (part, index) {
	      return _react2.default.createElement(
	        'p',
	        { key: 'part-' + index },
	        part
	      );
	    })
	  );
	};
	
	Address.propTypes = {
	  address: _propTypes2.default.array.isRequired
	};
	
	exports.default = Address;
	module.exports = exports['default'];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Map = function Map() {
	  return _react2.default.createElement("iframe", {
	    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.632624696453!2d-2.5892165847928603!3d51.50160881894838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487191ee1aa7e713%3A0xf0548cab06b303c6!2s50+Kenmore+Cres%2C+Bristol+BS7+0TR%2C+UK!5e0!3m2!1sen!2sus!4v1526586300943",
	    width: "430",
	    height: "400",
	    style: { border: 0 },
	    frameBorder: "0",
	    allowFullScreen: true });
	};
	
	exports.default = Map;
	module.exports = exports["default"];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n'], ['\n\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 0;\n\n  @media (min-width: 768px) {\n    padding-left: 3rem;\n  }\n'], ['\n  padding: 0;\n\n  @media (min-width: 768px) {\n    padding-left: 3rem;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Map = __webpack_require__(205);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Address = __webpack_require__(42);
	
	var _Address2 = _interopRequireDefault(_Address);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var AddressContainer = _styledComponents2.default.section(_templateObject);
	
	var MapContainer = _styledComponents2.default.div(_templateObject2);
	
	var Contact = function Contact(_ref) {
	  var data = _ref.data;
	  var contactDetails = data.site.siteMetadata.contactDetails;
	  var address = contactDetails.address,
	      telephoneNumber = contactDetails.telephoneNumber,
	      emailAddress = contactDetails.emailAddress,
	      socialMedia = contactDetails.socialMedia;
	
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Contact Ian Willmott'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Address'
	    ),
	    _react2.default.createElement(
	      AddressContainer,
	      null,
	      _react2.default.createElement(_Address2.default, { address: address }),
	      _react2.default.createElement(
	        MapContainer,
	        null,
	        _react2.default.createElement(_Map2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Telephone'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'tel:' + telephoneNumber },
	      telephoneNumber
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Email Address'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'mailto:' + emailAddress },
	      emailAddress
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Social Media'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'https://twitter.com/backsgetbetter?ref_src=twsrc%5Etfw',
	          target: '_blank',
	          rel: 'noopener noreferrer' },
	        'Twitter'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', rel: 'nopener noreferrer', href: socialMedia.facebook },
	        'Facebook'
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-6a69d5b299d5de2f9dbb.js